import axios from 'axios';

const API_BASE_URL = (import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000") + "/api/activity";

export const fetchCountries = async (setCountries) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/countries`);
    setCountries(response.data.data);
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};

export const fetchCities = async (countryId, setCities) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/user/cities/${countryId}`
    );
    setCities(response.data.data);
  } catch (error) {
    console.error("Error fetching cities:", error);
  }
};

export const fetchActivities = async (cityId, setActivities) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/user/activities/${cityId}`
    );
    setActivities(response.data.data);
  } catch (error) {
    console.error("Error fetching activities:", error);
  }
};

export const fetchActivityOptions = async (activityId, setActivityOptions) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/user/activity-options/${activityId}`
    );
    setActivityOptions(response.data.data);
  } catch (error) {
    console.error("Error fetching activity options:", error);
  }
};

export const fetchVisitorTypes = async (setVisitorTypes) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/visitor-types`);
    setVisitorTypes(response.data.data);
  } catch (error) {
    console.error("Error fetching visitor types:", error);
  }
};